import { Select } from "@mantine/core";

import { useAttachEntityMutation } from "../../hooks/mutations";
import { useDisplayedEntitiesQuery } from "../../hooks/useDisplayedEntitiesQuery";

/**
 * "Add entity" dropdown inside EntitiesDropTarget. Picking an entity from
 * the catalog calls attachEntity for the current query. Disabled when the
 * query already has a displayed entity — matches the original "only one
 * top-level entity per query" rule.
 */
export default function SelectEntityAccordion({ ruleId, queryId, entities }) {
  const { mutate: attachEntity } = useAttachEntityMutation({ ruleId });
  const { data: displayedEntities } = useDisplayedEntitiesQuery(queryId);

  if (!entities || entities.length === 0) {
    return null;
  }

  const hasEntities = Array.isArray(displayedEntities)
    ? displayedEntities.length > 0
    : false;

  return (
    <Select
      data={entities.map((e) => ({ value: String(e.id), label: e.name }))}
      placeholder="Add"
      value={null}
      onChange={(v) => {
        if (v == null) return;
        attachEntity({ entityId: Number(v), queryId });
      }}
      disabled={hasEntities}
      variant="filled"
      w={180}
      styles={{ input: { paddingLeft: "var(--mantine-spacing-md)" } }}
      allowDeselect
      clearable
    />
  );
}
